import './LeftBar.scss';
import { utility } from '@phi/components';
import { into } from '@vaaas/fpts/object';
import { defineComponent, h, PropType } from 'vue';
import ButtonDropdown, { Toggle } from './ButtonDropdown';

import Undo from './LeftBar/Undo';
import Redo from './LeftBar/Redo';

import Refresh from './LeftBar/Refresh';
import Upload from './LeftBar/Upload';
import Download from './LeftBar/Download';
import SendToOnshape from './LeftBar/SendToOnshape';
import Export from './LeftBar/Export';

import { ImportRefPartstudioButton } from '@features/references';
import ImportSTL from './LeftBar/ImportSTL';
import LoadSketches from './LeftBar/LoadSketches';

import ShowColors from './LeftBar/ShowColors';
import ShowMaterials from './LeftBar/ShowMaterials';
import ShowWireframe from './LeftBar/ShowWireframe';
import ShowHiddenEdges from './LeftBar/ShowHiddenEdges';

import { State } from '../state';
import EditPartstudio from './LeftBar/EditPartstudio';
import ShowPartstudio from './LeftBar/ShowPartstudio';
import ConvertPartstudio from './LeftBar/ConvertPartstudio';
import EditSTL from './LeftBar/EditSTL';
import ShowSTL from './LeftBar/ShowSTL';
import SaveSTL from './LeftBar/SaveSTL';
import CompressSTL from './LeftBar/CompressSTL';
import EditSketches from './LeftBar/EditSketches';
import ShowSketches from './LeftBar/ShowSketches';
import { IFrontendServiceContainer } from '@phi/frontend/service-container';

export default defineComponent({
    props: {
        state: { required: true, type: Object as PropType<State> },
        app: { required: true, type: Object as PropType<IFrontendServiceContainer> },
    },

    render() {
        const state = into(this.state);
        return h('div', {
            class: ['bar', 'left', utility.pointer_yes],
            ref: 'element',
        }, [
            h('div', { class: 'group' }, [
                h(Undo, { state: this.state }),
                h(Redo, { state: this.state }),
            ]),

            h('div', { class: 'group' }, [
                h(Refresh, { state: this.state }),
                h(Upload, { state: this.state }),
                h(Download, { state: this.state, auth: this.app.authentication }),
                h(SendToOnshape, { state: this.state, auth: this.app.authentication }),
                h(Export, { state: this.state, auth: this.app.authentication, subscriptions: this.app.subscriptions }),
            ]),

            h('div', { class: 'group' }, [
                h(ButtonDropdown, {
                    disabled: false,
                    id: 'import-partstudio-group',
                    direction: 'right',
                }, {
                    primary: () => h(ImportRefPartstudioButton, { state: this.state, auth: this.app.authentication }),
                    dropdown: (f: Toggle) => [
                        h(EditPartstudio, {
                            session_type: this.app.authentication.session_type.value,
                            state: this.state,
                            'onUpdate:disabled': f,
                        }),
                        h(ShowPartstudio, {
                            state: this.state,
                            session_type: this.app.authentication.session_type.value,
                            'onUpdate:disabled': f,
                        }),
                        h(ConvertPartstudio, {
                            state: this.state,
                            session_type: this.app.authentication.session_type.value,
                            'onUpdate:disabled': f,
                        }),
                    ],
                }),

                h(ButtonDropdown, {
                    disabled: false,
                    id: 'import-stl-group',
                    direction: 'right',
                }, {
                    primary: () => h(ImportSTL, { state: this.state, auth: this.app.authentication }),
                    dropdown: (f: Toggle) => [
                        h(EditSTL, {
                            state: this.state,
                            'onUpdate:disabled': f,
                        }),
                        h(ShowSTL, {
                            state: this.state,
                            session_type: this.app.authentication.session_type.value,
                            'onUpdate:disabled': f,
                        }),
                        h(SaveSTL, {
                            state: this.state,
                            session_type: this.app.authentication.session_type.value,
                            'onUpdate:disabled': f,
                            subscriptions: this.app.subscriptions,
                        }),
                        h(CompressSTL, {
                            state: this.state,
                            session_type: this.app.authentication.session_type.value,
                            'onUpdate:disabled': f,
                            subscriptions: this.app.subscriptions,
                        }),
                    ],
                }),

                h(ButtonDropdown, {
                    disabled: false,
                    direction: 'right',
                    id: 'load-sketches-group',
                }, {
                    primary: () => h(LoadSketches, { state: this.state, auth: this.app.authentication, subscriptions: this.app.subscriptions }),
                    dropdown: (f: Toggle) => [
                        h(EditSketches, {
                            state: this.state,
                            'onUpdate:disabled': f,
                        }),
                        h(ShowSketches, {
                            state: this.state,
                            'onUpdate:disabled': f,
                        }),
                    ],
                }),
            ]),

            h('div', { class: 'group' }, [
                h(ButtonDropdown, {
                    id: 'show-materials-group',
                    direction: 'right',
                    disabled: false,
                }, {
                    primary: () => h(ShowWireframe, {
                        tut_stage: this.state.tut_stage,
                        loaded: this.state.loaded,
                        wireframe_visible: this.state.wireframe_visible,
                        is_demo: this.state.is_demo,
                        editing_ref: this.state.editing_reference_partstudio
                            || this.state.editing_reference_sketches
                            || this.state.editing_reference_stl,
                        'onUpdate:wireframe_visible': state('wireframe_visible'),
                    }),
                    dropdown: (f: Toggle) => [
                        h(ShowColors, {
                            state: this.state,
                            'onUpdate:disabled': f,
                        }),
                        h(ShowMaterials, {
                            state: this.state,
                            'onUpdate:disabled': f,
                        }),
                    ],
                }),
                h(ShowHiddenEdges, {
                    loaded: this.state.loaded,
                    tut_stage: this.state.tut_stage,
                    hidden_edges_visible: this.state.hidden_edges_visible,
                    'onUpdate:hidden_edges_visible': state('hidden_edges_visible'),
                }),
            ]),
        ]);
    },
});
